export default __webpack_public_path__ + "aea72cf.png";